import orderBy from 'lodash/orderBy'
import querystring from 'querystring'
import { server } from '@/services'
import transformJson, { toLowerFirst } from '@/utils/transformJson'

const initialState = {
  vehicle: {
    vehicleId : null,
    arfPaid : null,
    coePaid : null,
    category : '',
    chasisNumber : '',
    colour : '',
    currentState : '',
    currentStation : '',
    dateSold : null,
    dateStartedCurrentStation : '',
    engineNumber : '',
    iuNumber : '',
    insuranceCertificate : [],
    insuranceCoveredBy : '',
    insurancePremium : null,
    licensePlate : '',
    make : '',
    model : '',
    nextPremiumRenewalDate : null,
    nextRoadTaxRenewal : null,
    purchaserName : '',
    registrationDate : '',
    remark : '',
    roadTaxAmount : null,
    sim : '',
    sellingPrice : null,
    telco : '',
    vehicleOwner : '',
    iBoxQnr : '',
    iBoxxLabelNo : '',
    iBoxxVersion : ''
  }
}

const state = {
  isFetching: false,
  isPosting: false,
  vehicleList: [],
  totalItems: 0,
  existingCerts: [],
  vehicle: {
    vehicleId : null,
    arfPaid : null,
    coePaid : null,
    category : '',
    chasisNumber : '',
    colour : '',
    currentState : '',
    currentStation : '',
    dateSold : null,
    dateStartedCurrentStation : '',
    engineNumber : '',
    iuNumber : '',
    insuranceCertificate : [],
    insuranceCoveredBy : '',
    insurancePremium : null,
    licensePlate : '',
    make : '',
    model : '',
    nextPremiumRenewalDate : null,
    nextRoadTaxRenewal : null,
    purchaserName : '',
    registrationDate : '',
    remark : '',
    roadTaxAmount : null,
    sim : '',
    sellingPrice : null,
    telco : '',
    vehicleOwner : '',
    iBoxQnr : '',
    iBoxxLabelNo : '',
    iBoxxVersion : ''
  },
  mrsVehicle: {}
}

const mutations = {
  SET_DATA: (state, payload) => {
    const keys = Object.keys(payload)
    keys.forEach((key) => {
      state[key] = payload[key]
    })
  },
  RESET_FORM: (state) => {
    state.vehicle = initialState.vehicle
  }
}

const actions = {
  fetchVehicles ({ commit }, payload) {
    commit('SET_DATA', { isFetching: true })
    const params = {...payload}
    server.get('/ops/getVehicles', params).then(
      ({ data }) => {
        commit('SET_DATA', {
          isFetching: false,
          vehicleList: orderBy(transformJson(data.msgContent.data, true), 'licensePlate', 'desc'),
          totalItems: data.msgContent.count
        })
      }
    )
  },
  download (_, params) {
    return server.get('/ops/getVehicles', params)
  },
  fetchVehicleBy ({ commit }, payload) {
    commit('SET_DATA', { isFetching: true })
    return new Promise((resolve) => {
      server.get(`/ops/getVehicleByLP/${payload}`).then(
        ({ data }) => {
          if (data.msgContent.data.length) {
            commit('SET_DATA', {
              isFetching: false,
              vehicleList: orderBy(transformJson(data.msgContent.data, true), 'licensePlate', 'desc'),
              totalItems: data.msgContent.count
            })
            resolve()
          }
        }
      )
    })
  },
  uploadCertificate(_, payload) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      if (payload.certs) {
        payload.certs.forEach((file) => {
          formData.append('certs', file)
        })
        
      }
      formData.append('licensePlate', payload.licensePlate);
      server.post('/proxy/cocos/uploadCertSharepoint', formData).then(
        (resp) => {
          resolve(resp.data)
        }
      ).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },
  saveVehicleRecord(_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/ops/upsertVRMS_Vehicle', payload).then(
        () => {
          resolve()
        }
      ).catch((err) => {
        reject()
      })
    })
  },
  shareCertificate(_, payload) {
    return server.post('/proxy/cocos/downloadSendAttachmentCI', payload)
  },
  getInsurances({ commit }, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCertInsurancesSP', payload).then(
        ({ data }) => {
          commit('SET_DATA', { existingCerts: toLowerFirst(data.msgContent.data) })
          resolve()
        }
      ).catch((err) => {
        reject(err)
      })
    })
  },
  fetchCarDevice({ commit }, payload) {
    commit('SET_DATA', { isFetching: true })
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCarDevice', payload).then(({ data }) => {
        commit('SET_DATA', { isFetching: false })
        const arrData = data.msgContent.data
        if (arrData.length) {
          const temp = arrData.pop()
          const vehicleList = [{
            licensePlate: payload.licensePlate,
            vehicleId: temp.CarId,
            telco : temp.SimProvider,
            currentState : temp.State,
            dateStartedCurrentStation: temp.StationFrom,
            currentStation: temp.Station,
            category: temp.Category,
            sim : temp.VoiceNumber,
            iBoxQnr : temp.IboxxQnr,
            iBoxxLabelNo : temp.IboxxLabelNo,
            iBoxxVersion : temp.IboxxVersion
          }]
          commit('SET_DATA', { vehicleList })
        }
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}